import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDirective } from 'angular-bootstrap-md';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Clothes } from 'src/app/models/Clothes';
import { DataClothes } from 'src/app/models/DataClothes';
import { DataOrder } from 'src/app/models/DataOrder';
import { NocSizes } from 'src/app/models/NocSizes';
import { Order } from 'src/app/models/Order';
import { Return } from 'src/app/models/Return';
import { ClothesService } from 'src/app/services/clothes.service';
import { ObservationService } from 'src/app/services/observation.service';
import { OrderService } from 'src/app/services/order.service';
import { CONSTANTES } from 'src/app/shared/global';

declare var jQuery: any;

@Component({
  selector: 'app-returns',
  templateUrl: './returns.component.html',
  styleUrls: ['./returns.component.scss']
})
export class ReturnsComponent implements OnInit {

  confirmChanges: boolean = false;
  orders: Order[] = []
  originalData: Order[] = []
  orderReturn: Return = new Return();
  dataFilter = ['Ticket', 'Nº Pedido', 'Noc/Código interno', 'Articulo'];
  filterSelected = "1";
  clothesList: Clothes[] = []
  clothes: string[] = []
  clothSelected: string
  sizes: NocSizes[] = []
  inputSelected: string = ''
  nid: string;
  sizeSelected: NocSizes;
  noc: string = ''; //almacena el noc o codigo interno
  observations: string = '';
  dataOrder: DataOrder;
  item: Clothes = undefined;
  amount = 0;
  totalPrice = 0;
  nocSizeSelected: NocSizes = undefined;
  //cintas
  selectedRibbon: string = '';
  selectedJob: string = '';
  selectedWeapon: string = '';
  selectedStaff: string = '';
  ribbons: string[] = [];
  jobs: string[] = [];
  weapons: string[] = [];
  staffs: string[] = [];
  ribbonNoc: NocSizes = undefined;
  priceInput: number = 0

  @ViewChild('confirmModal') confirmModal: ModalDirective;
  @ViewChild('printModal') printModal: ModalDirective;

  constructor(
    private orderService: OrderService, 
    private toastr: ToastrService, 
    private spinner: NgxSpinnerService,
    private clothesService: ClothesService,
    private router: Router,
    private observationService: ObservationService,) { }

  ngOnInit() {
    try{
      jQuery.getScript(CONSTANTES.menu);
      this.nid = localStorage.getItem("nid");
    } catch(Error){
      this.router.navigate(['login']);
    }
  }

  /**
   * Obtiene la información del artículo o del pedido para aplicar la devolución
   */
  async getOrderData(input: string){
    this.orders = undefined
    this.item = undefined
    if(this.filterSelected == 'Ticket'){
      await this.preSaveOrderReturn();
      this.orderReturn.returnType = this.filterSelected;
      this.spinner.show();
      this.orderService.getUnifyOrdersByStoreTicketNumber(input).subscribe(
        data => {
          if (getToken(data)) {
            if (data.orders !== undefined && data.orders !== null && data.orders.length > 0){
              //(<HTMLInputElement>document.getElementById("noc")).value = null;
              this.inputSelected = ''
              this.originalData = JSON.parse(JSON.stringify(data.orders));
              this.orders = data.orders
              this.orders.forEach(o=>{
                o.orderDetails.forEach(d=>{
                  d['max'] = d.amount
                  d['price'] = d.clothes.prices.filter(p => new Date(p.priceDate) < new Date(o.creationDate)) // Filtrar fechas menores
                  .sort((a, b) => new Date(b.priceDate).getTime() - new Date(a.priceDate).getTime())[0].price;
                })
              })
            } else {
              this.confirmModal.hide();
              this.toastr.warning("NO EXISTEN DATOS ASOCIADOS A ESE TICKET");
            }
            this.spinner.hide();
          }
        }, error => {
          this.spinner.hide();
          this.toastr.error("SE HA PRODUCIDO UN ERROR AL BUSCAR EL PEDIDO", "ERROR");
        }
      );
    } else if(this.filterSelected == 'Nº Pedido') {
      await this.preSaveOrderReturn();
      this.orderReturn.returnType = this.filterSelected;
      this.spinner.show();
      this.orderService.getOrderByOrderNumberAndStatus(input).subscribe(
        data => {
          if (getToken(data)) {
            if (data.orders !== undefined && data.orders !== null && data.orders.length > 0 && data.orders[0]!= null){
              //(<HTMLInputElement>document.getElementById("noc")).value = null;
              this.inputSelected = ''
              this.originalData = JSON.parse(JSON.stringify(data.orders));
              this.orders = data.orders
              this.orders.forEach(o=>{
                o.orderDetails.forEach(d=> {
                  d['max'] = d.amount;
                  d['price'] = d.clothes.prices.filter(p => new Date(p.priceDate) < new Date(o.creationDate)) // Filtrar fechas menores
                  .sort((a, b) => new Date(b.priceDate).getTime() - new Date(a.priceDate).getTime())[0].price;
              })
            })
              this.spinner.hide();
            } else {
              this.toastr.warning("NO EXISTEN DATOS ASOCIADOS A ESE PEDIDO");
              this.inputSelected = ''
              input = ''
              this.spinner.hide();
            }
          } else{
            this.spinner.hide();
            this.toastr.info("NO EXISTEN DATOS ASOCIADOS A ESE PEDIDO", "ERROR");
          }
        }, error => {
          this.spinner.hide();
          this.toastr.error("SE HA PRODUCIDO UN ERROR AL BUSCAR EL PEDIDO", "ERROR");
        }
      );
    } else if(this.filterSelected == 'Articulo' || this.filterSelected == 'Noc/Código interno'){
      await this.preSaveOrderReturn();
      this.orderReturn.returnType = this.filterSelected;
      if(input != ''){
        //this.item = this.clothesList.find(cloth=> cloth.nocSizes.some(noc=> noc.noc == input || noc.internalCode == input));
        this.spinner.show();
        let data = await this.clothesService.getNocSizeByNocOrInternalCode(input).toPromise();
        if (getToken(data)) {
          if (data.nocSize !== undefined && data.nocSize !== null){
            //(<HTMLInputElement>document.getElementById("noc")).value = null;
            this.inputSelected = '';
            this.nocSizeSelected = data.nocSize;
            this.item = data.nocSize.clothes;
            this.item.size= this.nocSizeSelected.size;
          } else {
            this.toastr.warning("SE HA PRODUCIDO UN ERROR AL BUSCAR EL ARTICULO");
            this.inputSelected = ''
            input = ''
          }
          this.spinner.hide();
        }else{
          this.spinner.hide();
          this.toastr.info("EL DATO INTRODUCIDO NO CORRESPONDE A NINGUN ARTICULO", "ERROR");
        }
      } else{
        this.spinner.hide();
        this.toastr.error("INTRODUZCA LA INFORMACION A BUSCAR");
      }
    } 
    this.ribbonNoc = undefined
    this.clothSelected=''
    this.sizeSelected = undefined
    this.selectedRibbon = ''
    this.selectedJob = ''
    this.selectedStaff = ''
    this.selectedWeapon = ''
  }

  /**
   * Guarda la devolucion para reservar el numero de ticket
   */
  async preSaveOrderReturn(){
    this.spinner.show();
    //let noc: string = (<HTMLInputElement>document.getElementById("noc")).value;
    let returnAux:Return = new Return();
    returnAux.action = '';
    returnAux.trackingDate = new Date;
    returnAux.nocSize = null;
    returnAux.order = null;
    returnAux.storeTicketNumber = '';
    returnAux.userNid = this.nid;
    returnAux.observations = '';
    returnAux.returnType = '';

    this.dataOrder = new DataOrder();
    this.dataOrder.orderReturn = returnAux;
    let data = await this.orderService.saveReturn(this.dataOrder).toPromise();
    if (getToken(data)) {
      //(<HTMLInputElement>document.getElementById("inputSelected")).value = null;
      this.orderReturn = data.orderReturn!;
    } else {
      this.toastr.warning(data.errorCode.message, "ERROR");
    }
    this.spinner.hide();
    
  }

  /**
   * Ejecuta una accion dependiendo del filtro seleccionado
   */
  async getAction(){
    this.orders = [];
    this.item = undefined;
    this.totalPrice = 0;
    this.amount = 0;
    if(this.filterSelected == 'Articulo'){
      this.clothesList = []
      this.clothes = []
      this.clothSelected = ''
      await this.getClothesList();
    }
  }

  /**
   * Devuelve una lista de articulos
   */
  async getClothesList(){
    this.spinner.show()
    let data = await this.clothesService.getClothesWithNocSizes().toPromise(); 
    if (data.clothes != null || data.clothes.length == 0) {
      this.clothesList = data.clothes;
      for (let i = 0; i < this.clothesList.length; i++) {
          if (this.clothesList[i].name != null){
            this.clothes.push(this.clothesList[i].name);
          }
      }
    }
    this.spinner.hide();
  }

  /**
   * Devuelve la lista de tallas del articulo seleccionado
   */
  getSizes(){
    this.sizes = []
    this.sizeSelected = undefined
    this.item = undefined
    this.spinner.show();
    if(this.clothSelected != 'CINTA'){
      this.sizes = this.clothesList.filter(c=> c.name == this.clothSelected).map(s=> s.nocSizes)[0]
    } else{
      this.sizes = [this.ribbonNoc];
    }
    this.spinner.hide();
  }

  /**
   * Decrementa el numero de devoluciones en 1 para devoluciones de ticket o pedido
   * @param storeTicketNumber 
   * @param orderDetail 
   */
  discountAmount(order: Order, storeTicketNumber: string, orderDetail: any){
    if (order.storeTicketNumber === storeTicketNumber){
      // Buscamos el detalle del pedido correspondiente con el artículo
      for (let i = 0; i < order.orderDetails.length; i++){
        if (order.orderDetails[i].clothes.code === orderDetail.clothes.code && order.orderDetails[i].size === orderDetail.size &&
          (order.orderDetails[i].ribbon ? order.orderDetails[i].ribbon.id == orderDetail.ribbon.id : order.orderDetails[i].ribbon == null) &&
          (order.orderDetails[i].job ? order.orderDetails[i].job.id == orderDetail.job.id : order.orderDetails[i].job == null)&&
          (order.orderDetails[i].weapon ? order.orderDetails[i].weapon.id == orderDetail.weapon.id: order.orderDetails[i].weapon == null) &&
          (order.orderDetails[i].generalStaff ? order.orderDetails[i].generalStaff.id == orderDetail.generalStaff.id : order.orderDetails[i].generalStaff == null)){
          let clothPrice = order.orderDetails[i].clothes.prices[order.orderDetails[i].clothes.prices.length - 1].price;
          if (order.orderDetails[i].amount > 1){
            order.orderDetails[i].amount -= 1;
          }
          order.price -= clothPrice;
        }
      }
    }
  }

  /**
   * Elimina el total de un articulo de un pedido para devoluciones de ticket o pedido
   * @param storeTicketNumber
   * @param clothName 
   */
  deleteItem(order: Order, storeTicketNumber: string, detail: any){
    this.spinner.show();
    // Recorremos los pedidos para localizar el artículo a eliminar
    if(storeTicketNumber === order.storeTicketNumber){
      for (let i = 0; i < order.orderDetails.length; i++){
        if (order.orderDetails[i].clothes.name === detail.clothes.name && order.orderDetails[i].size === detail.size &&
          (order.orderDetails[i].ribbon ? order.orderDetails[i].ribbon.id == detail.ribbon.id : order.orderDetails[i].ribbon == null) &&
          (order.orderDetails[i].job ? order.orderDetails[i].job.id == detail.job.id : order.orderDetails[i].job == null)&&
          (order.orderDetails[i].weapon ? order.orderDetails[i].weapon.id == detail.weapon.id: order.orderDetails[i].weapon == null) &&
          (order.orderDetails[i].generalStaff ? order.orderDetails[i].generalStaff.id == detail.generalStaff.id : order.orderDetails[i].generalStaff == null)){
          order.price -= order.orderDetails[i].clothes.prices[order.orderDetails[i].clothes.prices.length - 1].price * order.orderDetails[i].amount;
          // Eliminamos el artículo del pedido
          order.orderDetails.splice(i, 1);
        }
      }
    }
   this.spinner.hide()
  }

  /**
   * Incrementa el numero de devoluciones en 1
   * @param storeTicketNumber 
   * @param orderDetail 
   */
  increaseAmount(order: Order, storeTicketNumber: string, orderDetail: any){
    this.spinner.show()
    if (order.storeTicketNumber === storeTicketNumber){
      for (let i = 0; i < order.orderDetails.length; i++){
        if (order.orderDetails[i].clothes.code === orderDetail.clothes.code && order.orderDetails[i].size === orderDetail.size &&
          (order.orderDetails[i].ribbon ? order.orderDetails[i].ribbon.id == orderDetail.ribbon.id : order.orderDetails[i].ribbon == null) &&
          (order.orderDetails[i].job ? order.orderDetails[i].job.id == orderDetail.job.id : order.orderDetails[i].job == null)&&
          (order.orderDetails[i].weapon ? order.orderDetails[i].weapon.id == orderDetail.weapon.id: order.orderDetails[i].weapon == null) &&
          (order.orderDetails[i].generalStaff ? order.orderDetails[i].generalStaff.id == orderDetail.generalStaff.id : order.orderDetails[i].generalStaff == null)){
          let clothPrice = order.orderDetails[i].clothes.prices[order.orderDetails[i].clothes.prices.length - 1].price;
          if (order.orderDetails[i].amount >= 1 && order.orderDetails[i].amount < orderDetail.max){
            order.orderDetails[i].amount += 1;
            order.price += clothPrice;
          }
        }
      }
    }
    this.spinner.hide()
  }

  /**
   * Decrementa el numero de devoluciones en 1 para devolucion de articulos sueltos
   */
  discount(){
    if(this.amount > 0){
      this.amount -= 1;
      this.totalPrice = this.item.prices[this.item.prices.length -1].price * this.amount
    }
      
  }

  /**
   * Decrementa el numero de devoluciones en 1 para devolucion de articulos sueltos
   */
  increase(){
    this.amount += 1;
    this.totalPrice = this.item.prices[this.item.prices.length -1].price * this.amount
  }

  /**
   * Confirma la devolucion con los articulos
   */
  confirm(){
    this.spinner.show()
    this.dataOrder = new DataOrder;
    if(this.filterSelected == 'Ticket' || this.filterSelected == 'Nº Pedido'){
      if(this.confirmChanges){
        this.dataOrder.storeTicketNumber = this.orderReturn.storeTicketNumber;
        this.dataOrder.orders = this.orders;
        this.dataOrder.orderReturn = this.orderReturn;
        this.dataOrder.orderReturn.observations = this.observations
        this.dataOrder.orderReturn.returnType = this.filterSelected
        this.orderService.confirmReturn(this.dataOrder).subscribe(
          data => {
            if (getToken(data)) {
              if(data.orders != null && data.orders.length != 0){
                this.dataOrder.orders = data.orders;
                this.orders = data.orders;
                this.dataOrder.orderReturn.returnType = this.filterSelected;
                this.confirmModal.hide();
                this.printModal.show();
                this.spinner.hide();
              } else{
                this.toastr.warning("NO SE HAN PODIDO DEVOLVER LOS ARTICULOS");
                this.spinner.hide();
              }
            } else {
              this.confirmModal.hide();
              this.spinner.hide();
              this.toastr.warning(data.errorCode.message, "ERROR");
            }
          }, error => {
            this.confirmModal.hide();
            this.spinner.hide();
            this.toastr.error("SE HA PRODUCIDO UN ERROR AL REALIZAR LA DEVOLUCION", "ERROR");
          }
        );
      }else{
        this.confirmModal.hide();
        this.toastr.info("NO SE HAN DETECTADO CAMBIOS")
        this.spinner.hide()
      }
      
    } else {
      this.dataOrder.storeTicketNumber = this.orderReturn.storeTicketNumber;
      this.orderReturn.action = "+"+this.amount;
      this.orderReturn.purchasePrice = this.priceInput;
      this.dataOrder.noc = this.nocSizeSelected.id.toString();
      this.dataOrder.cloth = this.nocSizeSelected.clothes.code;
      this.orderReturn.observations = this.observations;
      this.orderReturn.order = null;
      this.dataOrder.orderReturn = this.orderReturn;
      this.dataOrder.orderReturn.userNid = this.nid;
      this.orderService.saveReturn(this.dataOrder).subscribe(data => {
        if (getToken(data)) {
          if(data.orderReturn != null){
            this.dataOrder.orderReturn = data.orderReturn;
            this.dataOrder.orderReturn.returnType = this.filterSelected;
            this.confirmModal.hide();
            this.printModal.show();
            this.spinner.hide();
          } else{
            this.confirmModal.hide();
            this.toastr.warning("NO SE HAN PODIDO DEVOLVER EL/LOS ARTICULOS");
            this.spinner.hide();
          }
        } else {
          this.spinner.hide();
          this.confirmModal.hide();
          this.toastr.warning(data.errorCode.message, "ERROR");
        }
      }, error => {
        this.spinner.hide();
        this.confirmModal.hide();
        this.toastr.error("SE HA PRODUCIDO UN ERROR AL REALIZAR LA DEVOLUCION", "ERROR");
      });
    }
    
  }

  /**
   * Comprueba que hay cambios en los pedidos para aplicar la devolucion
   */
  checkReturnChanges(){
    let changesBoolean = false;
    if(this.filterSelected == 'Ticket' || this.filterSelected == 'Nº Pedido'){
      this.originalData.forEach(originalOrder => {
        let actualOrder = this.orders.find(o=> originalOrder.id == o.id);
        originalOrder.orderDetails.forEach(originalDetail => {
          if (!actualOrder || actualOrder.orderDetails.length === 0) {
            changesBoolean = true;
            return;
          }
          let detail = actualOrder.orderDetails.find(d=>{ 
            return originalDetail['name'] === d['name'] &&
              originalDetail['size'] === d['size'] &&
              (originalDetail['ribbon'] ? originalDetail['ribbon'].id == d['ribbon'].id : originalDetail['ribbon'] == null) &&
              (originalDetail['job'] ? originalDetail['job'].id == d['job'].id : originalDetail['job'] == null)&&
              (originalDetail['weapon'] ? originalDetail['weapon'].id == d['weapon'].id: originalDetail['weapon'] == null) &&
              (originalDetail['generalStaff'] ? originalDetail['generalStaff'].id == d['generalStaff'].id : originalDetail['generalStaff'] == null);
            });

          if(!detail || detail['amount'] !== originalDetail['amount'])
            changesBoolean = true;
        })
      });
    } else {
      if(this.amount != 0 && this.priceInput != 0 && this.priceInput != undefined)
        changesBoolean = true
    }

    if(changesBoolean){
      this.confirmModal.show();
      this.confirmChanges = true
    } else{
      if(this.filterSelected == 'Ticket' || this.filterSelected == 'Nº Pedido')
        this.toastr.info("NO SE HAN DETECTADO CAMBIOS")
      else
        this.toastr.info("INTRODUZCA CANTIDAD Y PRECIO UNITARIO")
    }
      
  }

  /**
   * Genera el justificante del pedido
   **/
  print(){
    this.spinner.show();
    this.dataOrder.nid = localStorage.getItem("nid");
    this.dataOrder.role = localStorage.getItem("role");
    this.dataOrder.devolution = true;
    this.dataOrder.storeTicketNumber = this.orderReturn.storeTicketNumber;
    if(this.filterSelected !== 'Articulo' && this.filterSelected !== 'Noc/Código interno'){
      this.dataOrder.orders = Array.of(this.orders[0]);
    }
    if(this.item != undefined)
      this.dataOrder.noc = this.item.code; 
    this.orderService.getReceiptOrders(this.dataOrder).subscribe(
      data => {
        if (getToken(data)) {
          if(data.receiptOrders!=null){
            const source = 'data:application/pdf;base64,'+data.receiptOrders;
            const link = document.createElement("a");
            link.href = source;
            link.download = 'ticket'+new Date()+'+.pdf';
            link.click();
            this.closePrintModal();
            this.spinner.hide();
          }else{
            this.toastr.info("HA OCURRIDO UN ERROR AL GENERAR EL JUSTIFICANTE", "INFO");
            this.spinner.hide();
            this.router.navigate(['home']);
            this.spinner.hide();
          }
        } else {
          this.toastr.warning(data.errorCode.message, "ERROR");
          localStorage.clear();
          this.router.navigate(['login']);
          this.spinner.hide();
        }
      },
      (error) => {
        this.spinner.hide();
        this.toastr.error("HA OCURRIDO UN ERROR AL GENERAR EL JUSTIFICANTE", "ERROR");
      }
    )
  }
  

  /**
   * Cierra el modal de impresion y redigire al home
   */
  closePrintModal(){
    this.printModal.hide();
    this.router.navigate(['home']);
  }

  /**
   * Cancela la devolucion en curso
   */
  async cancel(){
    this.dataOrder.orderReturn = this.orderReturn
    let data = await this.orderService.cancelReturn(this.dataOrder).toPromise();
    if (getToken(data)) {
      this.toastr.success("DEVOLUCION CANCELADA")
    } else {
      this.toastr.warning(data.errorCode.message, "ERROR");
      localStorage.clear();
      this.router.navigate(['login']);
      this.spinner.hide();
    }

    this.orders = [];
    this.item = undefined;
    this.sizeSelected = undefined
    this.filterSelected = '1';
    
  }

  /**Obtiene la informacion para las cintas*/
  getInfoObservations(){
    this.sizes = []
    this.sizeSelected = undefined
    this.item = undefined
    this.spinner.show();
    this.observationService.getInfoObservation().subscribe(
      data=>{
        if(getToken(data)){
          if(data.ribbon != null && data.ribbon.length != 0 &&
            data.job != null && data.job.length != 0 &&
            data.weapon != null && data.weapon.length != 0 &&
            data.generalStaff != null && data.generalStaff.length != 0
          ){
            this.ribbons = data.ribbon;
            this.jobs = data.job;
            this.weapons = data.weapon;
            this.staffs = data.generalStaff;
            this.spinner.hide();
          }else{
            this.toastr.info("NO SE HAN OBTENIDO DATOS ASOCIADOS AL ARTICULO CINTA")
            this.spinner.hide();
          }
        }else{
          this.toastr.warning(data.errorCode.message, "ERROR");
          this.spinner.hide();
        }
      },(error) => {
        this.spinner.hide();
        this.toastr.error("HA OCURRIDO UN ERROR AL OBTENER LA INFORMACION", "ERROR");
      }
    )
  }

  /**
   * Obtiene el noc con los datos de la composicion de la cinta
   */
  getNocForRibbon(){
    this.spinner.show();
    if(this.selectedRibbon != '' && this.selectedJob != '' && this.selectedStaff != '' && this.selectedWeapon != ''){
      let data = [this.clothSelected, this.selectedRibbon, this.selectedJob, this.selectedWeapon, this.selectedStaff]
      let dataClothes: DataClothes = new DataClothes();
      dataClothes.search = data;
      this.clothesService.getNocSizeByObservations(dataClothes).subscribe(
        data=>{
          if(getToken(data)){
            if(data != null && data.nocSize != null){
              this.ribbonNoc = data.nocSize;
              this.getSizes();
            }else{
              this.toastr.info("NO SE HAN OBTENIDO DATOS ASOCIADOS AL ARTICULO CINTA")
              this.spinner.hide();
            }
          }else{
            this.toastr.warning(data.errorCode.message, "ERROR");
            this.spinner.hide();
          }
        },(error) => {
          this.spinner.hide();
          this.toastr.error("HA OCURRIDO UN ERROR AL OBTENER LA INFORMACION DE LA CINTA", "ERROR");
        }
      )
    } else
      this.toastr.info("COMPLETE TODOS LOS CAMPOS")
  }




}

/**
 * Devuelve la confirmacion de si el token está activo
 * @param data 
 * @returns 
 */
export function getToken(data: any) {
  if (data != null && data.token != null) {
      localStorage.setItem("token", data.token);
      return true;
  }
  return false;
}

